import configureStore from "../../../store/configureStore";

export default function dbGetAutoId(targetTable, idToken) {
  return dispatch => {
    //console.log("requeting id now");
    const state = configureStore.getState();
    let fbDbUrl = state.db.team.fbDbUrl;
    let fbCloudUrl = state.db.team.fbCloudUrl;
    let fetchQuery = "";

    fetchQuery = fbCloudUrl + "/getAutoId";
    //console.log("getID URL: " + fetchQuery);
    return fetch(fetchQuery, {
      method: "POST",
      body: JSON.stringify({ path: targetTable }),
      headers: {
        authorization: "Bearer " + idToken
      }
    })
      .then(res => res.json())
      .then(parsedRes => {
        //console.log("returning this from fb: " + JSON.stringify(parsedRes));
        return parsedRes;
      })
      .catch(err => {
        console.log(
          "[RECS] dbGetId(" +
            targetTable +
            "). We are unable to complete your request at this time, please check your network connection or contact support[getRecord][" +
            err +
            "]"
        );
      });
  };
}



// WEBPACK FOOTER //
// ./src/Services/Firebase/Generic/dbGetAutoId.js